/* oxlint-disable eslint/no-unused-vars, import/no-cycle -- LINTER migration follow up */
import { createFileRoute } from "@tanstack/react-router";
import { projectListSearchSchema } from "../../../../features/projects/project-trash/project-list-search";
import { TendersListPage } from "../../../../pages/tenders-list-page/tenders-list-page";

export const Route = createFileRoute("/_auth/_frame/tenders/")({
  validateSearch: (search) => {
    const parsed = projectListSearchSchema.parse(search);
    if (parsed.from === "deals") {
      const { from: _from, ...rest } = parsed;
      return rest;
    }
    return parsed;
  },
  component: TendersListPage,
});
